import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createVNode as _createVNode, renderList as _renderList, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71d3cac7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "view",
  "data-view": ""
}
const _hoisted_2 = { class: "box-menu" }
const _hoisted_3 = { class: "header__title" }
const _hoisted_4 = { class: "details" }
const _hoisted_5 = { class: "details__information details__information--classroom" }
const _hoisted_6 = { class: "details__information details__information--duration" }
const _hoisted_7 = { class: "details__information--container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "details__information details__information--enrollment-period" }, null, -1))
const _hoisted_9 = { class: "details__information--container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "details__information details__information--start-date" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "details__information--container"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "details__information details__information--time-period" }, null, -1))
const _hoisted_13 = { class: "details__information details__information--location" }
const _hoisted_14 = {
  key: 1,
  class: "details__information details__information--max-capacity"
}
const _hoisted_15 = {
  key: 2,
  class: "details__information details__information--max-capacity"
}
const _hoisted_16 = { class: "actions" }
const _hoisted_17 = { class: "section section--about" }
const _hoisted_18 = { class: "box-menu" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Sobre o evento:", -1))
const _hoisted_20 = { class: "event_description" }
const _hoisted_21 = {
  key: 0,
  class: "menu-container"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Ementa do evento:", -1))
const _hoisted_23 = {
  key: 1,
  class: "instructors-list"
}
const _hoisted_24 = ["onClick", "title"]
const _hoisted_25 = {
  key: 0,
  class: "section section--learn"
}
const _hoisted_26 = { class: "box-menu" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "O que você vai aprender?", -1))
const _hoisted_28 = {
  key: 1,
  class: "section section--instructors",
  "data-instructors": ""
}
const _hoisted_29 = { class: "box-menu" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Instrutores:", -1))
const _hoisted_31 = ["data-instructor-index"]
const _hoisted_32 = { class: "instructor__information" }
const _hoisted_33 = { class: "instructor__name" }
const _hoisted_34 = ["data-biography"]
const _hoisted_35 = { class: "instructor__button-see" }
const _hoisted_36 = ["data-see-more", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_TUIViewer = _resolveComponent("TUIViewer")!
  const _component_AccordionItem = _resolveComponent("AccordionItem")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", {
      class: "header",
      style: _normalizeStyle({ backgroundImage: `url(${$setup.eventCourse.bannerURL})` })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString($setup.eventCourse.name), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, " Turma: " + _toDisplayString($setup.eventClass.name), 1),
          _createElementVNode("span", _hoisted_6, " Duração: " + _toDisplayString($setup.formattedDuration($setup.eventClass.duration)), 1),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", null, " Período de inscrição: " + _toDisplayString($setup.formatDateWithTime(
                  $setup.eventClass.enrollmentStart,
                  $setup.eventClass.enrollmentEnd
                )), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", null, " Data de realização do evento: " + _toDisplayString($setup.formatDate($setup.eventClass.scheduleStart, $setup.eventClass.scheduleEnd)), 1)
          ]),
          ($setup.eventClass.scheduleStartDateTime)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", null, " Horário: " + _toDisplayString($setup.eventClassDateTime(
                  $setup.eventClass.scheduleStartDateTime,
                  $setup.eventClass.scheduleEndDateTime
                )), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_13, " Local: " + _toDisplayString($setup.eventClass.location), 1),
          ($setup.eventClass.maxCapacity)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, " Capacidade: " + _toDisplayString($setup.eventClass.enrollUsers?.length || 0) + " / " + _toDisplayString($setup.eventClass.maxCapacity), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_15, " Inscritos: " + _toDisplayString($setup.eventClass.enrollUsers?.length), 1))
        ]),
        _createElementVNode("div", _hoisted_16, [
          ($setup.showActionsButtons)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                ($setup.showIsentAttendance)
                  ? (_openBlock(), _createBlock(_component_ActionButton, {
                      key: 0,
                      label: "Ausente",
                      type: "red",
                      disabled: true
                    }))
                  : _createCommentVNode("", true),
                ($setup.showIsAttendance)
                  ? (_openBlock(), _createBlock(_component_ActionButton, {
                      key: 1,
                      label: "Presente",
                      type: "green",
                      disabled: true
                    }))
                  : _createCommentVNode("", true),
                ($setup.showAttendanceButton)
                  ? (_openBlock(), _createBlock(_component_ActionButton, {
                      key: 2,
                      label: "Confirmar presença",
                      type: "attendance",
                      onClick: $setup.confirmAttendance
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                ($setup.showEnrollButton)
                  ? (_openBlock(), _createBlock(_component_ActionButton, {
                      key: 3,
                      label: "Inscrever-se",
                      type: "enroll",
                      onClick: $setup.enrollUser
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                ($setup.showUnEnrollButton)
                  ? (_openBlock(), _createBlock(_component_ActionButton, {
                      key: 4,
                      label: "Cancelar inscrição",
                      type: "enroll",
                      onClick: $setup.unEnrollUser
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                ($setup.showContentsButton)
                  ? (_openBlock(), _createBlock(_component_ActionButton, {
                      key: 5,
                      label: "Acessar conteúdos",
                      type: "content",
                      onClick: $setup.redirectToFirstContent
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (
              $setup.eventClass.hasCertificate &&
                $setup.showIsAttendance &&
                $setup.isEventCompleted &&
                $options.isCirculoTemplate()
            )
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "header__certificate",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.openCertificate($setup.eventClass)), ["prevent"]))
              }, " Visualizar certificado "))
            : _createCommentVNode("", true),
          (
              $setup.eventClass.hasCertificate &&
                $setup.showIsAttendance &&
                $setup.isEventCompleted &&
                !$options.isCirculoTemplate()
            )
            ? (_openBlock(), _createBlock(_component_CustomDropdown, {
                key: 2,
                items: $setup.dropdownCertificateItems,
                title: "Certificação"
              }, null, 8, ["items"]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 4),
    _createElementVNode("section", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_TUIViewer, {
            "model-value": $setup.eventCourse.description
          }, null, 8, ["model-value"])
        ]),
        ($setup.eventCourse.menuMarkdown)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_TUIViewer, {
                "model-value": $setup.eventCourse.menuMarkdown
              }, null, 8, ["model-value"])
            ]))
          : _createCommentVNode("", true),
        ($setup.instructors)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.instructors, (instructor, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "instructors-list__item",
                  onClick: _withModifiers(($event: any) => ($setup.goToInstructor(index)), ["prevent"]),
                  style: _normalizeStyle(
              `left: ${index * 2}rem; background-image: url(${
                instructor.image
              })`
            ),
                  title: instructor.name
                }, [
                  _createElementVNode("div", {
                    class: "instructors-list__item__fade",
                    style: _normalizeStyle(`background-image: url(${instructor.image})`)
                  }, null, 4)
                ], 12, _hoisted_24))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    ($setup.contents.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createVNode(_component_Accordion, null, {
              default: _withCtx(() => [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.contents, (content, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, [
                      _createVNode(_component_AccordionItem, {
                        content: content,
                        onClickContent: ($event: any) => ($setup.onClickContent(content))
                      }, null, 8, ["content", "onClickContent"])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.instructors)
      ? (_openBlock(), _createElementBlock("section", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.instructors, (instructor, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  "data-instructor-index": index,
                  class: _normalizeClass([
              'instructor',
              { selected: $setup.selectedInstructorIndex === index }
            ])
                }, [
                  _createElementVNode("div", {
                    class: "instructor__image",
                    style: _normalizeStyle({ backgroundImage: `url(${instructor.image})` })
                  }, null, 4),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("span", _hoisted_33, _toDisplayString(instructor.name), 1),
                    _createElementVNode("p", {
                      "data-biography": index,
                      class: "instructor__biography"
                    }, _toDisplayString(instructor.biography), 9, _hoisted_34),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("button", {
                        "data-see-more": index,
                        class: "instructor__see-more",
                        onClick: ($event: any) => ($setup.seeMoreDescription(index))
                      }, " ver mais ", 8, _hoisted_36)
                    ])
                  ])
                ], 10, _hoisted_31))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}